export const callMimicApi = async () => {
    await new Promise(r => setTimeout(r, 1000));
    // Uncomment the exception below to test errors coming from the api
    // throw ('This is a test error.');
}
